import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  AuthoredEvidence,
  DictionaryEvidence,
  FormCustomField,
  FormPanel,
  FormSelect,
  FormTextField,
  TableField,
  useFormSelector,
} from '@eas/common-web';
import { useLanguages } from 'src/list-source/languages';
import { useDataSourceConfigColumns } from './data-source-columns';
import { DataSource } from '@models';
import { noop } from 'lodash';

export function Fields() {
  const language = useLanguages();

  const configColumns = useDataSourceConfigColumns();

  const { fieldConfigList = [] } = useFormSelector((data: DataSource) => ({
    fieldConfigList: data.fieldConfigList,
  }));

  const preparedConfigList = useMemo(
    () =>
      fieldConfigList
        .filter((config) => config.longText === false)
        .map((config) => ({ ...config, key: '${' + config.key + '}' })),
    [fieldConfigList]
  );

  return (
    <>
      <FormPanel
        label={
          <FormattedMessage
            id="TAPIS__DATA_SOURCE__DETAIL__PANEL_TITLE"
            defaultMessage="Obecné"
          />
        }
      >
        <FormTextField
          name="name"
          label={
            <FormattedMessage
              id="TAPIS__DATA_SOURCE__DETAIL__FIELD_LABEL__DOCUMENT_URL_MASK"
              defaultMessage="Název zdroje"
            />
          }
          required
        />
        <FormSelect
          name="language"
          label={
            <FormattedMessage
              id="TAPIS__DATA_SOURCE__DETAIL__FIELD_LABEL__LANGUAGE"
              defaultMessage="Jazyk"
            />
          }
          source={language}
          valueIsId
          disabled
        />
        <FormTextField
          name="owner"
          label={
            <FormattedMessage
              id="TAPIS__DATA_SOURCE__DETAIL__FIELD_LABEL__OWNER"
              defaultMessage="Majitel"
            />
          }
          required
        />
        <FormTextField
          name="area"
          label={
            <FormattedMessage
              id="TAPIS__DATA_SOURCE__DETAIL__FIELD_LABEL__AREA"
              defaultMessage="Oblast"
            />
          }
          required
        />
        <FormCustomField label="Nápověda">
          <TableField
            columns={configColumns}
            showDetailBtnCond={() => false}
            maxRows={5}
            onChange={noop}
            value={preparedConfigList}
            showToolbar
            disabled
          />
        </FormCustomField>
        <FormTextField
          name="documentUrlMask"
          label={
            <FormattedMessage
              id="TAPIS__DATA_SOURCE__DETAIL__FIELD_LABEL__DOCUMENT_URL_MASK"
              defaultMessage="Maska URL detailu dokumentu"
            />
          }
          helpLabel="Šablonu zadejte ve formátu [freemarker](https://freemarker.apache.org/index.html)."
        />

        <FormTextField
          name="incrementalImportCron"
          label={
            <FormattedMessage
              id="TAPIS__DATA_SOURCE__DETAIL__FIELD_LABEL__CRON"
              defaultMessage="CRON inkrementálního importu"
            />
          }
          helpLabel="Formát např: '0 1 * * */6'. Více informací na [Crontab](https://crontab.guru/)."
        />
      </FormPanel>

      <FormTextField
        name="code"
        label={
          <FormattedMessage
            id="TAPIS__DATA_SOURCE__DETAIL__FIELD_LABEL__CODE"
            defaultMessage="Kód"
          />
        }
        disabled
      />
      <DictionaryEvidence.FieldOrder />
      <DictionaryEvidence.FieldActive />
      <AuthoredEvidence.AuthoredFields />
    </>
  );
}
